module.exports = __webpack_public_path__ + "static/media/beforeUnloadImg.5a975e0c.png";